
import { Component, Vue } from 'vue-property-decorator';
import { courseSelectData } from '@/static/data/course';

@Component({
  name: 'sampleLesson',
})
export default class extends Vue {
  public selectID: number = 0;
  public selectSeq: number = 0;
  public courseList: any[] = [];
  get courseInfo() {
    return courseSelectData.filter((v: any) => (v.id === this.selectID))[0];
  }
  public created() {
    let id = +this.$route.params.id;
    this.courseList = courseSelectData
    if (id){
      const data:any = courseSelectData.find((v: any) => (v.id === id));
      this.selectID = data.id;
      this.selectSeq = data.seq;
    }else{
      this.selectID = courseSelectData[0].id;
      this.selectSeq = courseSelectData[0].seq;
    }  
  }
  public goPrev() {
    if (this.courseList.length >= 1) {
      this.selectSeq = this.selectSeq - 1;
      if (this.selectSeq <= 0) {
        this.selectSeq = this.courseList[this.courseList.length-1].seq
      }
      const courseInfo:any = this.courseList.find((v: any) => (v.seq === this.selectSeq));
      this.selectID = courseInfo.id;
    }
  }
  public goNext() {
    if (this.courseList.length >= 1) {
      this.selectSeq = this.selectSeq + 1;
      if (this.selectSeq>this.courseList.length-1) {
        this.selectSeq = 1;
      }
      const courseInfo:any = this.courseList.find((v: any) => (v.seq === this.selectSeq));
      this.selectID = courseInfo.id;
  }
  }
  public goCourseAll() {
    window.location.href = '../CourseList';
  }
}
